function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{opacity:0.1;fill:#6C63FF;enable-background:new    ;}\n\t.st1{opacity:0.8;}\n\t.st2{fill:#65617D;}\n\t.st3{fill:#DCE0ED;}\n\t.st4{opacity:0.1;enable-background:new    ;}\n\t.st5{fill:#F0F0F4;}\n\t.st6{fill:#636780;}\n\t.st7{opacity:0.1;fill:#FFFFFF;enable-background:new    ;}\n\t.st8{fill:#6C63FF;}\n\t.st9{opacity:0.15;enable-background:new    ;}\n\t.st10{fill:none;stroke:#000000;stroke-miterlimit:10;}\n\t.st11{fill:#FFFFFF;}\n\t.st12{fill:#A8A8A8;}\n\t.st13{opacity:0.2;enable-background:new    ;}\n\t.st14{fill:#444053;}\n\t.st15{fill:#ffc0cb;}\n\t.st16{opacity:0.3;fill:#6C63FF;enable-background:new    ;}\n\t.st17{fill:none;}\n\t.st18{fill:#9FA4FF;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st19{font-family:'MyriadPro-Regular';}\n\t.st20{font-size:148px;}\n\t.st21{letter-spacing:13;}\n");

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  className: "st0",
  cx: 557,
  cy: 419.8,
  rx: 557,
  ry: 173.8
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  className: "st1"
}, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M404.8,35.4c9.4,13.2,16.7,51.8,18.7,63.4l16.9-0.3c-0.9-10-20.5-50.6-26-61.7 C411.4,36.3,408.1,35.8,404.8,35.4z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 192.5,
  y: 28.4,
  transform: "matrix(1.888322e-02 -0.9998 0.9998 1.888322e-02 161.9391 229.2309)",
  className: "st3",
  width: 10.5,
  height: 7.5
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M194.1,26.8l-0.1,3.4c0.5,0.2,1.1,0.2,1.6,0.3l5.9,0.1l0.1-3.6L194.1,26.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M205.3,0.1L198.2,0c-3.4-0.1-6.6,2-7.9,5.1c-2.2,5-4.1,13.1,0.4,21.3c1,1.9,2.9,3,5.1,3l9,0.1L205.3,0.1z"
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1.888322e-02 -0.9998 0.9998 1.888322e-02 186.2869 219.5151)",
  className: "st5",
  cx: 205,
  cy: 14.8,
  rx: 14.7,
  ry: 7.6
}), /*#__PURE__*/React.createElement("rect", {
  x: 259.6,
  y: 29.1,
  transform: "matrix(1.888322e-02 -0.9998 0.9998 1.888322e-02 226.3863 296.3538)",
  className: "st3",
  width: 9.2,
  height: 7.5
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M260.5,28.1l-0.1,2.9c0.5,0.2,1.1,0.2,1.6,0.3l5.9,0.1l0.1-3.1L260.5,28.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M271.7,1.5l-7.1-0.1c-3.4-0.1-6.6,2-7.9,5.1c-2.2,5-4.1,13.1,0.4,21.3c1,1.9,2.9,3,5.1,3l9,0.1L271.7,1.5z"
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1.888003e-02 -0.9998 0.9998 1.888003e-02 250.0662 287.2674)",
  className: "st5",
  cx: 271.4,
  cy: 16.2,
  rx: 14.7,
  ry: 7.6
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M269.7,6.9c0,0,2.8,0.5,1.3,4.2c-0.8,1.8-1.4,3.6-1.8,5.5c0,0-2.8,1.4-2.6-3.4S269.7,6.9,269.7,6.9z"
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1.888322e-02 -0.9998 0.9998 1.888322e-02 316.4143 767.0747)",
  className: "st6",
  cx: 549.1,
  cy: 222.3,
  rx: 48.4,
  ry: 44.1
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M533.4,176.7c23.1,2,40.9,23.3,40.5,49c-0.4,20.7-12.6,38.1-29.4,44.7c-23.1-2-40.9-23.3-40.5-49 C504.3,200.7,516.6,183.2,533.4,176.7z"
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1.888307e-02 -0.9998 0.9998 1.888307e-02 91.8168 313.8232)",
  className: "st6",
  cx: 205.8,
  cy: 110.1,
  rx: 46.7,
  ry: 35.8
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M216.7,65.6c14.7,6,25.2,24.1,24.8,45.3c-0.4,22.7-13.2,41.3-29.7,45.2c-14.7-6-25.2-24.1-24.8-45.3 C187.4,88.2,200.2,69.5,216.7,65.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M340.5,102.7l-0.3-17c0,0,3.5-7.2,6.8-7.8s11-0.9,11-0.9s5.5,24.5,1.4,31.7 C355.2,115.9,340.5,102.7,340.5,102.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M340.5,102.7l-0.3-17c0,0,3.5-7.2,6.8-7.8s11-0.9,11-0.9s5.5,24.5,1.4,31.7 C355.2,115.9,340.5,102.7,340.5,102.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M401.8,102c0,0,2.5-23.5-10.4-24.1c-1.7-0.1-3.3-0.2-5-0.3c-8.9-1-33.3-3.4-30.5,2.3c0,0,5.4,20.5,1.3,25.6 L401.8,102z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M218,142.1l-17.3,0.2c0,0-2.4-32-3.3-34.5s-1.2-14.5,2.1-16.2s14.2-3.6,14.2-3.6l7.6,18.3l0.3,16.5L218,142.1z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M218,142.1l-17.3,0.2c0,0-2.4-32-3.3-34.5s-1.2-14.5,2.1-16.2s14.2-3.6,14.2-3.6l7.6,18.3l0.3,16.5L218,142.1z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M260.9,90l0.1-3.6c0-1.1-0.8-2.1-2-2.1c0,0-0.1,0-0.1,0c-8.6,0.2-39.9,1.1-45.4,3.8c0,0,5.1,44.6-1.7,55.1 l1.6,35.7l76.6-4.3L260.9,90z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M267.9,33.9c-2.1-0.2-4.6-0.5-7.5-0.8l-0.1,4.3l7.5,0.1L267.9,33.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M193.9,36.8l0,0.5l7.5,0.1l0.1-3.2C198.9,34.7,196.3,35.6,193.9,36.8z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "154.4,142.1 165.7,142.4 189.9,100.5 193.9,93.4 191.3,75.4 188.9,79.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "257.6,91.8 262.1,98.9 276.4,80.4 282.9,71.9 279.2,66.6 276.2,70.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M276.2,70.1c0,0.4-0.1,0.7-0.1,1.1l0.3,9.1l6.5-8.5l-3.7-5.2L276.2,70.1z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "188.9,79.8 189.9,100.5 193.9,93.4 191.3,75.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M289.2,83.6c0,0,6.4-41.6-13.8-48.2c-0.3-0.1-0.5-0.1-0.8-0.2c-4.7-0.7-48.1-6.5-70.9-1c0,0-15.5,2-15.5,10.3 l4.9,101.6l11.1,0.2l-2.4-67.2c0,0-4.8-29.3,4.1-31.2s48.9-4.4,63-0.1c0,0,10.3-2.1,8.2,23.3l0.4,13.6L289.2,83.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M255,95.4c-0.1-2.2,0.9-4.4,2.7-5.7c3.2-2.3,12.9-7.2,12.9-7.2l3.1,0.3l8.9,23.4l-1.6,49.2l-17.2,20.5 L255,95.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M255,95.4c-0.1-2.2,0.9-4.4,2.7-5.7c3.2-2.3,12.9-7.2,12.9-7.2l3.1,0.3l8.9,23.4l-1.6,49.2l-17.2,20.5 L255,95.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M321.2,148.2l0.6-50.5c0,0,1.9-19.6-9.8-20.1c0,0-27.6-0.3-39.7,3.3c-1.4,0.4-2.2,1.9-1.8,3.3 c0.1,0.2,0.1,0.3,0.2,0.5c2.3,4.2,6.1,15.3,7.5,43.6l-0.6,30.3L321.2,148.2z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "262.3,179.4 312.6,179.2 312.6,179.2 337.3,179.1 335.1,146 321.4,146.2 277.6,155.1 263.9,175.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "262.3,179.4 312.6,179.2 312.6,179.2 337.3,179.1 335.1,146 321.4,146.2 277.6,155.1 263.9,175.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "262.3,179.4 312.6,179.2 313.8,157 277.6,155.1 263.9,175.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M312.6,179.2l24.7-0.1l-2.2-33.1c0,0-8,12.2-21.3,11.1L312.6,179.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M134.8,202.5c0.8,9.5,7.6,8.1,7.6,8.1l1.3-0.1l12.5-0.9l-0.2-14.7c-4.2-0.3-8.5-0.1-12.6,0.5 C138.6,196.3,134.5,198.3,134.8,202.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M134.8,202.5c0.8,9.5,7.6,8.1,7.6,8.1l1.3-0.1c1.4-2.1,2.1-4.6,2.1-7.1c0.2-2.9-0.7-5.7-2.5-8 C138.6,196.3,134.5,198.3,134.8,202.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M308.6,109.5c-0.3,15.4,8.7,28,20.1,28.2s20.8-12.1,21.1-27.4s-8.7-28-20.1-28.2S308.9,94.1,308.6,109.5z  M316.4,111.5c0.2-11.1,7.4-20.1,16.1-19.9s15.5,9.3,15.3,20.5c-0.2,11.1-7.4,20.1-16.1,19.9S316.2,122.6,316.4,111.5L316.4,111.5z "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "328.1,118.4 318.2,127.7 314.9,119.2 329,111.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st8",
  points: "315.6,24.4 307.2,25.3 304,28.9 308.4,50.2 317.7,84.6 323.9,108.3 328.2,122.6 330.8,141.5  333.5,154.6 342.2,163.6 360.6,142.7 363.7,135.7 371,121.3 352.9,112.5 332.9,110.3 323.9,85.9 316.8,57.8  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st2",
  points: "483.4,128.8 492.7,221.1 354.7,212.7 371.5,167.8 398.4,151 337.6,150.8 337.7,125.6 362.4,120.7  412,117.7 449.3,116.7 484.6,129  "
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st4",
  points: "483.4,128.8 492.7,221.1 354.7,212.7 371.5,167.8 398.4,151 337.6,150.8 337.7,125.6 362.4,120.7  412,117.7 449.3,116.7 484.6,129  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M293.1,217c-0.4,22.9,6.8,43.8,27.9,42c26.6-0.1,29-18,29.5-40.9s-12.1-40.1-27.9-40.4S293.5,194.1,293.1,217z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M292.9,217c0.3-17.7,8.3-31.8,19.2-37.1c13.9,2.9,24.2,19.1,23.8,40c-0.4,18.7-2.1,34.2-17.3,39.2 C299.2,259.4,292.5,239.1,292.9,217z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st8",
  points: "266.7,180.6 274.6,190 260,187.3 249.3,177 240,157.4 226.4,148.7 192.7,152.6 161.6,153.2  150.3,142.8 163.1,141.3 176.1,141.3 208.7,141.1 247.5,140.8 255.1,162.2 260.8,176.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M154.4,216.4c0.6,1,22.3,4.7,22.3,4.7l59.9,12.1l103.3,3.4l12.3-10.1l6.3,1.3l0.3,0l84.8,16.7l1.4-0.2 l23.3-2.9l121.5-15l-1-17.6l-0.6-10.4l-1.3-21.6l-1.1-5.7l-10.8-1.2l-5-0.6l-78.5-8.7l-10.3-1.1l-5.8-0.6l-56-8.7l-81.9,0.4 l0.1-25.3L307.2,25.3c-7.2,1-7.1,5.8-7.1,5.8l25.8,94.4l-0.8,57.7c-57.5,4.7-59.1-7.8-68.2-3.8l-10.3-35.3l-96.4-1.3 C146.4,147.4,154.4,216.4,154.4,216.4z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "394.4,168.5 362.6,233.6 352.3,236.7 350,226 362.1,189.9 374.3,169  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st9",
  points: "394.4,168.5 362.6,233.6 352.3,236.7 350,226 362.1,189.9 374.3,169  "
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1.887955e-02 -0.9998 0.9998 1.887955e-02 164.0194 649.5117)",
  className: "st6",
  cx: 413,
  cy: 241.2,
  rx: 62.8,
  ry: 55.4
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M394.3,181.9c28.9,2.6,51.4,30.3,50.7,63.7c-0.5,26.9-15.9,49.6-37,58.1c-28.9-2.6-51.4-30.3-50.7-63.7 C357.9,213.1,373.2,190.5,394.3,181.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M563.4,134.2l2.5,13l7.6,39.7l36.1-2.8c0,0,2.3-6.6-3.3-9.2c0,0-1.4-22.5-8-29.7c-0.7-0.8-1.6-1.5-2.6-1.9 L563.4,134.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M565.9,147.1l7.6,39.7l36.1-2.8c0,0,2.3-6.6-3.3-9.2c0,0-1.4-22.5-8-29.7L565.9,147.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M482.1,136.1c-4.8,7.7,5.1,79.9,5.1,79.9l88.8-13l-2-63c-1.6-11.3-8.2-12.8-8.2-12.8 c-30.9-16.4-102.6-21.1-102.6-21.1c-65.5,1.3-125.5,19.4-125.5,19.4C412.4,115.5,482.1,136.1,482.1,136.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M487.3,216l88.8-13l-2-63c-1.6-11.3-8.2-12.8-8.2-12.8s-64.5-7.4-83.8,8.9C477.3,143.8,487.3,216,487.3,216z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M496.7,212l74.3-11.1l-1.6-53.8c-1.3-9.7-6.9-10.9-6.9-10.9s-53.9-6.3-70,7.6C488.4,150.5,496.7,212,496.7,212 z"
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1.888322e-02 -0.9998 0.9998 1.888322e-02 326.2108 668.3092)",
  className: "st4",
  cx: 503.6,
  cy: 167.9,
  rx: 18.4,
  ry: 10.1
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1.888322e-02 -0.9998 0.9998 1.888322e-02 326.7184 667.8296)",
  className: "st3",
  cx: 503.6,
  cy: 167.4,
  rx: 18.4,
  ry: 10.1
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M502.6,153.8c0,0,4.1,0.7,1.9,6.2c-1.2,2.6-2.1,5.4-2.6,8.3c0,0-4.2,2.1-3.9-5.1S502.6,153.8,502.6,153.8z"
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1.888322e-02 -0.9998 0.9998 1.888322e-02 385.9314 716.6002)",
  className: "st4",
  cx: 558.1,
  cy: 161.7,
  rx: 17.2,
  ry: 9.5
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1.888322e-02 -0.9998 0.9998 1.888322e-02 386.439 716.1205)",
  className: "st3",
  cx: 558.1,
  cy: 161.2,
  rx: 17.2,
  ry: 9.5
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M557,147.5c0,0,4.1,0.7,1.9,6.2c-1.2,2.6-2.1,5.4-2.6,8.3c0,0-4.2,2.1-3.9-5.1S557,147.5,557,147.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M515.6,152.5c0.5,6.8,2.9,57.4,2.9,57.4l5.7-0.8l3.1-0.5l4.2-0.6l0.5-0.1l16.5-2.4l-2.2-53.6 c-0.2-3.6-3.1-6.4-6.7-6.4c-0.2,0-0.3,0-0.5,0c-1.1,0.1-2.4,0.2-3.6,0.3c-0.5,0-1.1,0.1-1.6,0.2c-1.6,0.2-3.2,0.4-4.8,0.6 c-0.8,0.1-1.6,0.3-2.4,0.4c-1.3,0.2-2.6,0.5-3.8,0.8c-0.8,0.2-1.6,0.4-2.3,0.7C517.4,149.4,515.4,150.8,515.6,152.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M539.6,145.4l2.1,60.3l1.8-0.1l-2.1-59.9C540.8,145.5,540.2,145.4,539.6,145.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M533.8,145.9l1.9,60.9l2.8,0.1l-3.1-61.1C534.9,145.8,534.3,145.8,533.8,145.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M526.5,146.9l3.6,61.1l1.8,0l0-0.1l-3-61.4C528.1,146.6,527.3,146.8,526.5,146.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M520.4,148.4l3.7,60.7l0,0.1l3.2-0.3l0-0.3l-4.6-60.9C521.9,147.9,521.1,148.2,520.4,148.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M587.1,196.6c0,0,6.7-31.4-7.2-33.3s-59.8,0.6-58.7,13.6s2.2,32.7,2.2,32.7l9.5-1.9c0,0-6.5-29.8,4.6-30.7 s38.3-3.5,38.3-3.5s7.4-1.1,2.6,24.9L587.1,196.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M587,199.6c0,0,6.7-33.4-7.2-35.3s-59.8,0.6-58.7,13.6s2.2,32.7,2.2,32.7l9.5-1.9c0,0-6.5-29.8,4.6-30.7 s38.3-3.5,38.3-3.5s7.3,0.9,2.6,26.8L587,199.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M340,236.6l12.3,0.1c9.7-39.4,25-63.7,25-63.7c5-2.6,59.5-1.2,59.5-1.2c5.6,1.1,6.8,19.1,6.8,19.1 s-4.9,4.1-0.3,6.8c2.1,1.2,8.9,1.6,16.8,1.3c9.8-0.3,21.2-1.6,27.1-3.3c10.7-3.1,2.3-9.4,2.3-9.4s-1.5-2-2.2-13 c-0.6-6.4-2.5-12.6-5.7-18.2c-0.4-0.8-0.7-1.2-0.7-1.2c-0.5-0.5-1.2-1-1.9-1.3c-14-6.1-83.1-1.8-83.1-1.8l-25.7,7.7 c-0.7,0.3-1.8,2.1-3.2,4.9C358.4,180.5,340,236.6,340,236.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M340,236.6l12.3,0.1c9.7-39.4,25-63.7,25-63.7c5-2.6,59.5-1.2,59.5-1.2c5.6,1.1,6.8,19.1,6.8,19.1 s-4.9,4.1-0.3,6.8c2.1,1.2,8.9,1.6,16.8,1.3c9.8-0.3,21.2-1.6,27.1-3.3c10.7-3.1,2.3-9.4,2.3-9.4s-1.5-2-2.2-13 c-0.6-6.4-2.5-12.6-5.7-18.2c-0.4-0.8-0.7-1.2-0.7-1.2c-0.5-0.5-1.2-1-1.9-1.3c-14-6.1-83.1-1.8-83.1-1.8l-25.7,7.7 c-0.7,0.3-1.8,2.1-3.2,4.9C358.4,180.5,340,236.6,340,236.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M366.8,163.3c23.8-8.7,88.8-2.6,88.8-2.6c7-5.8,20-5.9,25.9-5.6c-0.4-0.8-0.7-1.2-0.7-1.2 c-0.5-0.5-1.2-1-1.9-1.3c-14-6.1-83.1-1.8-83.1-1.8l-25.7,7.7C369.3,158.7,368.2,160.5,366.8,163.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M451.7,163.1c1.4,5.2,7.2,25.9,7.2,25.9c0.6,3.3,1,6.6,1.2,10c9.8-0.3,21.2-1.6,27.1-3.3 c10.7-3.1,2.3-9.4,2.3-9.4s-1.5-2-2.2-13c-0.6-6.9-2.8-13.5-6.4-19.4c-0.5-0.5-1.2-1-1.9-1.3C469.6,154.6,450.6,159.2,451.7,163.1z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M451.7,163.1c1.4,5.2,7.2,25.9,7.2,25.9c0.6,3.3,1,6.6,1.2,10c9.8-0.3,21.2-1.6,27.1-3.3 c10.7-3.1,2.3-9.4,2.3-9.4s-1.5-2-2.2-13c-0.6-6.9-2.8-13.5-6.4-19.4c-0.5-0.5-1.2-1-1.9-1.3C469.6,154.6,450.6,159.2,451.7,163.1z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M307.2,25.3l30.5,100.3L465,107.2l-16.8-60.3c0,0-2.6-13.8-9.2-14.9C439,32,337.3,12.4,307.2,25.3z M321.4,41 c-4.1-13.5,56.3-6.8,56.3-6.8c8.1-0.6,17.9,0.1,27.1,1.2c3.3,0.4,6.6,0.9,9.6,1.3c6.8,1.1,12.5,2.2,16,2.9c2.2,0.5,3.4,0.7,3.4,0.7 c12,4,17.9,53.9,17.9,53.9c0.9,5.3-5.3,4-5.3,4l-0.4,0l-5.7,0.1l-16.9,0.3l-82.3,1.7c-4.9-0.6-5.5-6.3-5.5-6.3 C333.2,90,321.4,41,321.4,41z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M446,98.4l0.4,0c0,0,6.2,1.2,5.3-4c0,0-5.9-50-17.9-53.9c0,0-1.3-0.3-3.4-0.7C434.6,48.3,448.1,77.9,446,98.4z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M446,98.4l0.4,0c0,0,6.2,1.2,5.3-4c0,0-5.9-50-17.9-53.9c0,0-1.3-0.3-3.4-0.7C434.6,48.3,448.1,77.9,446,98.4z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M432.6,221.1c1.4,2.8,4.3,4.5,7.4,4.4l2.5-0.1l24-0.6l8.6-0.2l8-0.5L588.8,209l-0.6-10.4l-12.1,1.5l-5,0.6 l-74.6,9.2l-9.8,1.2l-4.8,0.6l-20.1-0.5l-21.8-0.6c-1.1,0-2.2,0.2-3.2,0.6c-1.9,0.7-3.4,2.1-4.3,3.9 C431.6,217,431.6,219.2,432.6,221.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M432.5,222.1c1.4,2.8,4.3,4.5,7.4,4.4l35.2-0.9l8-0.5L595.7,209l8.9-1.3l4.8-0.7c9.5-1.8,6.9-11.3,6.9-11.3 c-0.6-4.3-16.8-8.6-22.1-8.6c-3.6,0-4.2,5.5-4.2,9.1c0,1.8,0.1,3.1,0.1,3.1l-5.3,0.7l-103,12.8l-41.9-1.1c-3.2-0.1-6.1,1.6-7.5,4.5 C431.5,218,431.6,220.2,432.5,222.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M601.7,193.2c0,0-4.6,5.4-11.6,6.1C590.1,199.3,593.1,193.2,601.7,193.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M602.6,208.7c0,0,14.8-0.1,14.6,7.9s-9.5,9.1-9.5,9.1l-132.6,22.9l-37.6,0c0,0-12.9-10.7,0.8-15.1l37.9,1.7 l126.4-20.7C602.6,214.5,599.4,210,602.6,208.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M437.6,249.6l37.6,0L593,229.3l8.6-1.5l6.1-1c0,0,9.3-1.2,9.5-9.1c0.1-5.7-7.5-7.3-11.8-7.8 c-1.7-0.2-2.9-0.2-2.9-0.2c-3.2,1.3,0.1,5.8,0.1,5.8l-4.6,0.8l-121.8,20l-37.9-1.7C424.7,238.9,437.6,249.6,437.6,249.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M591.6,202l-7.7-3.6l-4-0.2l-0.3,33.6l12.3-2.3l5.2-3.2l2.8-13.9c0,0-0.9-5.8-1.4-6.3S591.6,202,591.6,202z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M591.6,202l-7.7-3.6l-4-0.2l-0.3,33.6l12.3-2.3l5.2-3.2l2.8-13.9c0,0-0.9-5.8-1.4-6.3S591.6,202,591.6,202z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M593,229.3c-0.1,0.1-0.1,0.2-0.1,0.2l8.7-1.5c0-0.1,0.1-0.1,0.1-0.2c4.7-7.3,5.2-13.2,3.8-17.9 c-1.7-0.2-2.9-0.2-2.9-0.2c-3.2,1.3,0.1,5.8,0.1,5.8l-4.6,0.8C598.2,222.8,593.9,228.3,593,229.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M580.8,198.1c1.4,0.6,2.8,1.2,4,1.8c5.5,2.8,8.9,5.9,10.9,9l8.9-1.3c-3.7-8-12.8-11.8-12.8-11.8l-1.9,0.4 L580.8,198.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M590.9,195.8c0,0,24.1,10.1,9.7,32.1l-8.7,1.5c0,0,17.5-19.3-12-31.3L590.9,195.8z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st3",
  points: "532.8,205.6 523.9,205.1 524.7,241.1 539.2,238.7 545.4,235.9 548.4,228.8 550.5,221.7 545.8,215.1  540.4,211.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "532.8,205.6 523.9,205.1 524.7,241.1 539.2,238.7 545.4,235.9 548.4,228.8 550.5,221.7 545.8,215.1  540.4,211.3  "
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1.888322e-02 -0.9998 0.9998 1.888322e-02 299.2673 753.3337)",
  className: "st3",
  cx: 533.5,
  cy: 224.2,
  rx: 7.3,
  ry: 4.3
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M574.5,234.9c1.2,0.5,1.7,1.9,1.2,3.1c0,0.1-0.1,0.1-0.1,0.2c-1,1.8-2.2,4.2-2.1,4.8c0.2,1.1-2.2,0.1-2.5-0.1 s-4.6-0.1-4.8-3c0-1.8,0.9-3.5,2.4-4.4l-0.9-6.4l5.9-0.4l-0.2,5.9L574.5,234.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M574.5,234.9c1.2,0.5,1.7,1.9,1.2,3.1c0,0.1-0.1,0.1-0.1,0.2c-1,1.8-2.2,4.2-2.1,4.8c0.2,1.1-2.2,0.1-2.5-0.1 s-4.6-0.1-4.8-3c0-1.8,0.9-3.5,2.4-4.4l-0.9-6.4l5.9-0.4l-0.2,5.9L574.5,234.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M572.9,234.7c0,0-2.1,6.8-1.3,7.1S572.9,234.7,572.9,234.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M570.7,233.1c0,0-2.1,6.8-1.3,7.1S570.7,233.1,570.7,233.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M547.2,212l2.9,20.7c0,0,4.1-0.5,6.4-0.9c0.5-0.1,1-0.2,1.4-0.4c0.1-0.1,0.4-0.1,0.7,0l0,0 c1.1,0.2,3.1,1.2,3.5,0.4c0-0.1,0.1-0.1,0.1-0.2l0,0c0.4-0.4,1.1-0.1,1.9,0c0.4,0.1,0.8,0.1,1.2-0.1c0.6-0.4,1.8,0.3,2.9,0.5 c0.6,0.2,1.2,0.1,1.5-0.4c0.2-0.4,0.6-0.6,1-0.7l0,0c1-0.2,2.3,0,3.1-0.2c0.3-0.1,0.5-0.2,0.6-0.4c0.2-0.4,1-0.6,1.9-0.8 c1.1-0.2,2.3-0.3,2.4-0.8c0-0.1,0.1-0.2,0.3-0.2c0.6,0.1,1.2,0.3,1.8,0.5l0,0c0.5,0.1,0.9,0.1,1-0.2c0.1-0.4,0.7-0.3,1.4-0.2 c0.5,0.1,1.1,0.4,1.6,0.5c0.4,0.1,0.7,0.1,0.7-0.1c0.2-0.7,2.3,0.9,2.8-0.4s7.5-10-1.1-21.6c0,0-2.4,0.1-4.2,0.4 c-0.6,0.1-1.2,0.2-1.8,0.5c0,0,0,0,0,0c-1,0.3-2.1,0.4-3.2,0.3c-0.6,0-1.2,0.1-1.8,0.4c-0.2,0.1-0.4,0.3-0.5,0.5 c-0.3,0.6-0.9,0.7-1.6,0.7c-0.9-0.1-2-0.5-2.4-0.3c0,0,0,0,0,0c-0.7,0.3-3.3-0.1-3.8,0.4c0,0,0,0,0,0c-0.2,0.3-1.2,0-2.2-0.2l0,0 c-0.7-0.2-1.5-0.1-2.1,0.3c-0.5,0.4-1,0.5-1.6,0.4c-0.7-0.1-1.4-0.1-2.1,0c-0.2,0-0.3,0.1-0.4,0.3c-0.4,0.5-1.4,0.4-2.3,0.5 c-0.5,0-0.9,0.1-1.3,0.3c-0.1,0.1-0.3,0.2-0.5,0.2c-1.3,0.1-2.7,0-4-0.3L547.2,212z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M583.1,228.6c0.5,0.1,1.1,0.4,1.6,0.5c6.9-10.3,1.4-18.4-1.7-21.7c-0.6,0.1-1.2,0.2-1.8,0.5 C587.8,215.7,584.5,225.4,583.1,228.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M578.9,228.5c0.6,0.1,1.2,0.3,1.8,0.5l0,0c6-10.1,0.2-17.9-2.8-20.9c-0.6,0-1.2,0.1-1.8,0.4 C582.5,215.7,580.4,224.4,578.9,228.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M573.7,230.6c0.3-0.1,0.5-0.2,0.6-0.4c0.2-0.4,1-0.6,1.9-0.8c5.2-9.2,0.8-16.3-2.2-19.8 c-0.9-0.1-2-0.5-2.4-0.3c0,0,0,0,0,0C578.6,217.6,575,227.7,573.7,230.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M568.1,232c0.6,0.2,1.2,0.1,1.5-0.4c0.2-0.4,0.6-0.6,1-0.7l0,0c6.1-10.2,0.2-18-2.7-21c0,0,0,0,0,0 c-0.2,0.3-1.2,0-2.2-0.2C573.8,218.3,569.3,229.5,568.1,232z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M562.2,231.5c0.4-0.4,1.1-0.1,1.9,0c6.3-10.1,0.8-17.9-2.2-21.2c-0.7-0.1-1.4-0.1-2.1,0 C566.8,218.3,563.6,228.1,562.2,231.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M556.5,231.7c0.5-0.1,1-0.2,1.4-0.4c0.1-0.1,0.4-0.1,0.7,0l0,0c5.6-9.2,1.4-16.5-1.6-20.1 c-0.5,0-0.9,0.1-1.3,0.3c-0.1,0.1-0.3,0.2-0.5,0.2C561,219.5,557.8,228.7,556.5,231.7z"
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1.888322e-02 -0.9998 0.9998 1.888322e-02 143.9068 634.3282)",
  className: "st6",
  cx: 395.2,
  cy: 243.8,
  rx: 39.9,
  ry: 27.1
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1.888322e-02 -0.9998 0.9998 1.888322e-02 144.1939 635.8184)",
  className: "st4",
  cx: 396.1,
  cy: 244.4,
  rx: 32.3,
  ry: 19.7
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1.888322e-02 -0.9998 0.9998 1.888322e-02 145.209 634.8591)",
  className: "st5",
  cx: 396.1,
  cy: 243.4,
  rx: 32.3,
  ry: 19.7
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1.888322e-02 -0.9998 0.9998 1.888322e-02 163.8512 610.3589)",
  className: "st6",
  cx: 392.9,
  cy: 221.7,
  rx: 4,
  ry: 2.3
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1.888322e-02 -0.9998 0.9998 1.888322e-02 119.3688 634.4563)",
  className: "st6",
  cx: 383,
  cy: 256.4,
  rx: 4,
  ry: 2.3
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1.888322e-02 -0.9998 0.9998 1.888322e-02 160.4276 644.0173)",
  className: "st6",
  cx: 408.4,
  cy: 240.3,
  rx: 4,
  ry: 2.3
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1.888322e-02 -0.9998 0.9998 1.888322e-02 130.1865 659.4618)",
  className: "st6",
  cx: 401.1,
  cy: 263.4,
  rx: 4,
  ry: 2.3
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M198.4,166.3c0,0-20.4,51.5-19.5,54.7c0,0-8.3,4.8-10.3,3.5s0.2-24.2,0.2-24.2l4.1-20.1l4.5-11.9L198.4,166.3z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M198.4,166.3c0,0-20.4,51.5-19.5,54.7c0,0-8.3,4.8-10.3,3.5s0.2-24.2,0.2-24.2l4.1-20.1l4.5-11.9L198.4,166.3z "
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1.888322e-02 -0.9998 0.9998 1.888322e-02 138.1662 610.2899)",
  className: "st6",
  cx: 380,
  cy: 234.7,
  rx: 4,
  ry: 2.3
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1.888322e-02 -0.9998 0.9998 1.888322e-02 140.503 632.4205)",
  className: "st6",
  cx: 392.5,
  cy: 244.6,
  rx: 9.5,
  ry: 6.8
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M175.4,235.2c-0.6,30,8.9,57.5,36.6,55c34.9-0.1,38.1-23.6,38.7-53.6s-15.9-52.7-36.6-53 S175.9,205.2,175.4,235.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M175.1,235.2c0.4-23.2,10.9-41.7,25.2-48.6c18.2,3.8,31.8,25.1,31.3,52.4c-0.5,24.6-2.7,44.8-22.7,51.4 C183.4,290.9,174.6,264.2,175.1,235.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M160.9,222.2c0,0,4.9,4.3,7.7,1.4c0,0,7.7-53.7,16.2-53.8l29.2,0.3c0,0,3.5,1.6,4.8,8.1l17.8,54l103.3,3.4 l8.2-16.4l-85.5-1.4l0,0c-0.4-1.7-13.7-52.9-23.2-59.5c0,0,0,0,0,0c-0.3-0.2-0.7-0.4-1-0.5c0,0-35.5-5.4-47.3-2.4 c0,0-12.3,2.5-15.3,6.2c0,0,0,0,0,0c-0.4,0.4-5.1,5.5-6.8,20.5L160.9,222.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M160.9,223.2c0,0,4.9,4.3,7.7,1.4c0,0,7.7-53.7,16.2-53.8l29.2,0.3c0,0,3.5,1.6,4.8,8.1l17.8,54l103.3,3.4 l8.2-16.4l-85.5-1.4l0,0c-0.4-1.7-13.7-52.9-23.2-59.5c0,0,0,0,0,0c-0.3-0.2-0.7-0.4-1-0.5c0,0-35.5-5.4-47.3-2.4 c0,0-12.3,2.5-15.3,6.2c0,0,0,0,0,0c-0.4,0.4-5.1,5.5-6.8,20.5L160.9,223.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M160.9,223.2c0,0,4.9,4.3,7.7,1.4c0,0,7.7-53.7,16.2-53.8l29.2,0.3c0,0,3.5,1.6,4.8,8.1l17.8,54l103.3,3.4 l8.2-16.4l-85.5-1.4l0,0c-0.4-1.7-13.7-52.9-23.2-59.5c0,0,0,0,0,0c-0.3-0.2-0.7-0.4-1-0.5c0,0-35.5-5.4-47.3-2.4 c0,0-12.3,2.5-15.3,6.2c0,0,0,0,0,0c-0.4,0.4-5.1,5.5-6.8,20.5L160.9,223.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M225.3,165.6c2.4,4.8,22.7,63.5,22.7,63.5l14.7-10.2l0,0c-0.4-1.7-13.8-53-23.2-59.5 C233.2,160.3,223.7,162.3,225.3,165.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M253.7,139.5l11,38.6l61.1-0.6l-0.6,5.7c0,0-48,6.1-68.2-3.8l-10.3-35.3l-96.4-1.3l18.4-4L253.7,139.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M253.7,139.5l11,38.6l61.1-0.6l-0.6,5.7c0,0-48,6.1-68.2-3.8l-10.3-35.3l-96.4-1.3l18.4-4L253.7,139.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M538.8,205.3c0,0,32.4,17.1,7.9,32.1l-6.5,1.4c0,0,24.1-16.7-15.3-33.7L538.8,205.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M537.8,205.3c0,0,32.4,17.1,7.9,32.1l-6.5,1.4c0,0,24.1-16.7-15.3-33.7L537.8,205.3z"
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1.888322e-02 -0.9998 0.9998 1.888322e-02 -45.1212 433.7676)",
  className: "st6",
  cx: 198.5,
  cy: 239.9,
  rx: 31.2,
  ry: 18.2
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1.888322e-02 -0.9998 0.9998 1.888322e-02 -45.2152 435.0398)",
  className: "st4",
  cx: 199.1,
  cy: 240.6,
  rx: 25.3,
  ry: 13.2
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1.888322e-02 -0.9998 0.9998 1.888322e-02 -44.2001 434.0805)",
  className: "st5",
  cx: 199.1,
  cy: 239.6,
  rx: 25.3,
  ry: 13.2
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1.888322e-02 -0.9998 0.9998 1.888322e-02 -29.2597 415.338)",
  className: "st6",
  cx: 197,
  cy: 222.6,
  rx: 3.1,
  ry: 1.6
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1.888322e-02 -0.9998 0.9998 1.888322e-02 -63.0314 435.2012)",
  className: "st6",
  cx: 190.2,
  cy: 249.7,
  rx: 3.1,
  ry: 1.6
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1.888322e-02 -0.9998 0.9998 1.888322e-02 -33.5969 439.8741)",
  className: "st6",
  cx: 207.3,
  cy: 237.1,
  rx: 3.1,
  ry: 1.6
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1.888322e-02 -0.9998 0.9998 1.888322e-02 -56.5052 452.6995)",
  className: "st6",
  cx: 202.4,
  cy: 255.1,
  rx: 3.1,
  ry: 1.6
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1.888322e-02 -0.9998 0.9998 1.888322e-02 -47.996 416.6916)",
  className: "st6",
  cx: 188.3,
  cy: 232.8,
  rx: 3.1,
  ry: 1.6
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(1.888322e-02 -0.9998 0.9998 1.888322e-02 -47.5004 432.5736)",
  className: "st6",
  cx: 196.7,
  cy: 240.5,
  rx: 7.4,
  ry: 4.6
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M465.2,106.3c0,0-55.4,0.9-127.5,19.3L465.2,106.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M203.1,4.5c0,0,3,0.5,1.4,4.5c-0.9,1.9-1.5,3.9-1.9,6c0,0-3,1.5-2.8-3.7S203.1,4.5,203.1,4.5z"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "319.5,99.2 323.9,116.7 339.1,103.4  "
}), /*#__PURE__*/React.createElement("rect", {
  x: 297.1,
  y: 115.3,
  transform: "matrix(0.1692 -0.9856 0.9856 0.1692 129.3945 429.6462)",
  className: "st11",
  width: 44.8,
  height: 45.6
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M313.9,157.7l0.8-4.9c-2.6-0.5-5.1-1.6-7.1-3.4l1.7-3.1c2.1,1.8,4.6,2.9,7.2,3.4c3.5,0.6,6.1-1,6.6-3.8 c0.5-2.7-1.2-4.7-4.5-6.7c-4.6-2.8-6.8-5.5-6-9.7c0.7-4,3.8-6.7,8.4-6.6l0.8-4.9l2.5,0.4l-0.8,4.7c2.2,0.4,4.3,1.4,6,2.8l-1.8,3 c-1.6-1.4-3.5-2.3-5.6-2.7c-3.8-0.6-5,1.5-5.3,3.4c-0.4,2.5,0.6,4,4.5,6.5c4.7,2.9,7.3,6,6.6,10.3c-0.7,3.9-4,7-9.1,7l-0.9,5.1 L313.9,157.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M313.1,317.7c0.8,0,1.5-0.7,1.4-1.6c0-0.8-0.7-1.4-1.4-1.4c-0.8,0-1.5,0.7-1.4,1.6 C311.7,317,312.3,317.6,313.1,317.7z"
}));

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  className: "st0",
  cx: 663.9,
  cy: 451.6,
  rx: 18.7,
  ry: 3.2
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M651.4,437c0,0,10.7-0.3,13.9-2.6s16.4-5,17.2-1.3s16,18.2,4,18.3s-27.9-1.9-31.2-3.8S651.4,437,651.4,437z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M686.6,450.1c-12,0.1-27.9-1.9-31.2-3.8c-2.4-1.5-3.4-6.8-3.7-9.3c-0.2,0-0.4,0-0.4,0s0.7,8.6,3.9,10.5 s19.1,3.9,31.2,3.8c3.5,0,4.7-1.3,4.6-3.1C690.5,449.3,689.2,450,686.6,450.1z"
});

var _ref8 = /*#__PURE__*/React.createElement("ellipse", {
  className: "st0",
  cx: 772.2,
  cy: 414.8,
  rx: 14.4,
  ry: 2.4
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M762.6,403.6c0,0,8.2-0.3,10.7-2s12.6-3.9,13.2-1s12.3,14,3.1,14.1s-21.5-1.4-24-2.9S762.6,403.6,762.6,403.6z "
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M789.7,413.6c-9.3,0.1-21.5-1.4-24-2.9c-1.9-1.1-2.6-5.2-2.9-7.1c-0.2,0-0.3,0-0.3,0s0.5,6.6,3,8.1 s14.7,3,24,2.9c2.7,0,3.6-1,3.5-2.4C792.7,413.1,791.7,413.6,789.7,413.6z"
});

var _ref11 = /*#__PURE__*/React.createElement("ellipse", {
  className: "st0",
  cx: 707,
  cy: 568.4,
  rx: 34.3,
  ry: 5.8
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M684,541.5c0,0,19.6-0.6,25.5-4.8s30.1-9.2,31.6-2.5c1.5,6.7,29.4,33.5,7.3,33.7s-51.3-3.4-57.2-7 C685.2,557.3,684,541.5,684,541.5z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M748.7,565.5c-22.1,0.2-51.3-3.4-57.2-7c-4.5-2.7-6.3-12.5-6.9-17.1c-0.4,0-0.7,0-0.7,0s1.2,15.8,7.1,19.4 c5.9,3.6,35.1,7.2,57.2,7c6.4-0.1,8.6-2.3,8.5-5.7C755.9,564.2,753.5,565.5,748.7,565.5z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M1069.3,364.3c0,49.3-40,89.3-89.3,89.3c-46.4,0-85-35.5-89-81.7c-0.1-1.5-0.2-2.9-0.3-4.4v-0.1 c0-1.1-0.1-2.1-0.1-3.2c0-49.3,40-89.3,89.3-89.3S1069.3,314.9,1069.3,364.3L1069.3,364.3z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M1069.3,364.3c0,49.3-40,89.3-89.3,89.3c-46.4,0-85-35.5-89-81.7c-0.1-1.5-0.2-2.9-0.3-4.4v-0.1 c0-1.1-0.1-2.1-0.1-3.2c0-49.3,40-89.3,89.3-89.3S1069.3,314.9,1069.3,364.3L1069.3,364.3z"
});

var _ref16 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.3827 -0.9239 0.9239 0.3827 268.3964 1130.2312)",
  className: "st3",
  cx: 980,
  cy: 364.3,
  rx: 48.7,
  ry: 48.7
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 980,
  cy: 364.3,
  r: 29.2
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M592.4,364.3c0,49.3-40,89.3-89.3,89.3c-46.4,0-85-35.5-89-81.7c-0.1-1.5-0.2-2.9-0.3-4.4v-0.1 c0-1.1-0.1-2.1-0.1-3.2c0-49.3,40.1-89.3,89.4-89.3C552.4,275,592.3,315,592.4,364.3L592.4,364.3z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M592.4,364.3c0,49.3-40,89.3-89.3,89.3c-46.4,0-85-35.5-89-81.7c-0.1-1.5-0.2-2.9-0.3-4.4v-0.1 c0-1.1-0.1-2.1-0.1-3.2c0-49.3,40.1-89.3,89.4-89.3C552.4,275,592.3,315,592.4,364.3L592.4,364.3z"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  className: "st3",
  cx: 503,
  cy: 364.3,
  r: 48.7
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 503,
  cy: 364.3,
  r: 29.2
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M1097.2,347.5l-29.8-1.3l-27.2-50.5l-95.9-7.8l-46.7,60.9l2.6,16.8l-6.5,15.6l-304.5,2.6V376h-2.6l-2.6-11.7 h23.3l-16.8-18.1l-59.6-50.5c0,0-102.4,2.6-103.7,0s5.8-29.2,5.8-29.2l44.1-13l150.3-11.7c33-52.5,62.9-77.1,62.9-77.1h386.2 l18.1,93.3v0.2L1097.2,347.5z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M882,354c0,0,38.9-72.6,68.7-72.6h72.6c0,0,18.1,0,25.9,14.3L1079,354h-23.3c0,0-19.4-54.4-41.5-55.7 s-59.6,0-59.6,0s-13,0-20.7,15.6s-34.1,49.4-34.1,49.4S871.7,372.2,882,354z"
});

var _ref24 = /*#__PURE__*/React.createElement("polygon", {
  className: "st15",
  points: "1114,342.4 1065.3,342.4 1064.8,381.2 1114,369.6 "
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M409,319c0,0,2.6-19.4,20.7-27.2l119.2-6.5c0,0,19.4,1.3,29.8,25.9l33.7,50.5v7.8h-37.6c0,0-18.1-68.7-70-66.1 h-62.2c0,0-14.3,0-19.4,23.3L409,319z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M688.9,172.6L688.9,172.6h397.9l0,0c0-7.9-6.4-14.3-14.3-14.3H703.2C695.3,158.3,688.9,164.7,688.9,172.6 L688.9,172.6z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M774.2,249H664.1c-4.1,0-7.4-3.3-7.4-7.4c0-1,0.2-2.1,0.6-3l17.4-39.2c5.5-12.4,17.7-20.3,31.3-20.3h66.9 c5.2,0,9.4,4.2,9.4,9.4l0,0V241C782.2,245.4,778.6,249,774.2,249L774.2,249z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M816.3,179.1h96.5c3.1,0,5.5,2.5,5.5,5.5v58.9c0,3.1-2.5,5.5-5.5,5.5h-96.5c-3.1,0-5.5-2.5-5.5-5.5v-58.9 C810.7,181.5,813.2,179.1,816.3,179.1z"
});

var _ref29 = /*#__PURE__*/React.createElement("polygon", {
  className: "st15",
  points: "1094.6,258.1 1094.6,258.3 927.4,260.7 923,164.8 1076.4,164.8 "
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M947.2,179.1h112c3.1,0,5.5,2.5,5.5,5.5v58.9c0,3.1-2.5,5.5-5.5,5.5h-112c-3.1,0-5.5-2.5-5.5-5.5v-58.9 C941.6,181.5,944.1,179.1,947.2,179.1z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M750.3,273.7h38c1,0,1.8,0.8,1.8,1.8v4.3c0,1-0.8,1.8-1.8,1.8h-38c-1,0-1.8-0.8-1.8-1.8v-4.3 C748.5,274.5,749.3,273.7,750.3,273.7z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M869.5,273.7h38c1,0,1.8,0.8,1.8,1.8v4.3c0,1-0.8,1.8-1.8,1.8h-38c-1,0-1.8-0.8-1.8-1.8v-4.3 C867.8,274.5,868.6,273.7,869.5,273.7z"
});

var _ref33 = /*#__PURE__*/React.createElement("rect", {
  x: 951.7,
  y: 171.3,
  className: "st11",
  width: 48,
  height: 47.2
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M973.4,216.3V211c-2.8,0-5.6-0.8-8-2.3l1.2-3.5c2.5,1.5,5.2,2.2,8.1,2.2c3.7,0,6.2-2.1,6.2-5.1 c0-2.9-2-4.6-5.9-6.2c-5.3-2.1-8-4.5-8-9c0-4.3,2.8-7.6,7.6-8.4v-5.3h2.6v5.1c2.4,0,4.7,0.6,6.8,1.8l-1.3,3.4 c-1.9-1.2-4-1.8-6.3-1.8c-4,0-4.9,2.4-4.9,4.5c0,2.7,1.3,4.1,5.9,5.9c5.4,2.2,8.7,4.9,8.7,9.5c0,4.1-2.9,8-8.2,8.9v5.4H973.4z"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "st17",
  d: "M370.6,418.1c-6.2,6.7-10.8,9.4-10.5,2.3c0.7-21.5-37.1-118.7-37.1-118.7l11.2-0.8 C358.5,342.9,367.6,386.1,370.6,418.1z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M423.9,465c0,29.7-24.1,53.8-53.8,53.8c-27.9,0-51.2-21.3-53.6-49.1c-0.1-0.9-0.1-1.7-0.2-2.6v0 c0-0.6,0-1.3,0-1.9c0-29.7,24.1-53.7,53.8-53.7C399.9,411.4,423.9,435.4,423.9,465L423.9,465z"
});

var _ref37 = /*#__PURE__*/React.createElement("circle", {
  className: "st3",
  cx: 370.2,
  cy: 465,
  r: 29.3
});

var _ref38 = /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 370.2,
  cy: 465,
  r: 17.6
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M229,362.9l-129.4,2.6v-19.1c1.2-15.4,16.9-20.7,31.3-22.4c11.2-1.3,22.6-0.4,33.4,2.5 c27.5,7.3,45,8.7,53.6,8.8c3.9,0.1,7.2,2.9,7.9,6.7c0.4,2.2,0.8,4.6,1.2,6.9c0.3,1.8,0.6,3.6,0.8,5.3 C228.5,359.2,229,362.9,229,362.9z"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M332.3,468.5H63.4c-4.2,0-8.1-2.5-9.8-6.3c-2-4.8,0.8-7.9,3.8-9.7c6.2-3.7,10.9-9.4,13.2-16.2 c2.9-8.4,5.7-21.7,6.8-42.4c1.1-21.4,8.9-32,17.3-37.1h0c10.8-6.6,22.7-4.1,22.7-4.1l109,0.9c1.9,0.9,3.7,2.1,5.3,3.5 c9.7,9-4.5,20.9-4.5,20.9c-30.4,32.1-7.4,64.7-7.4,64.7h55.8c10.4,0.1,20.6-3.1,29.2-8.9c7.5-5.2,10.5-10.2,11.6-13.3 c0.9-2.3,1.7-4.7,2.8-6.9c14.6-31.7-3-83.4-10.6-102.7c-1.9-4.8-3.2-7.6-3.2-7.6l17.5-1.3l11.1-0.8l0.1,0 c24.4,42.1,33.4,85.3,36.5,117.3c0.3,3,0.5,5.9,0.7,8.8c1.4,21.5-14.9,40.2-36.5,41.6C334,468.5,333.1,468.5,332.3,468.5z"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M227.8,354.3H99.6v-5.3H227C227.3,350.8,227.6,352.6,227.8,354.3z"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M231.7,356.9h-136c-0.4,0-0.7-0.1-1-0.2c10.8-6.6,22.7-4.1,22.7-4.1l109,0.9 C228.3,354.3,230.1,355.4,231.7,356.9z"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M48.1,350.2h184.7c1.5,0,2.7,1.2,2.7,2.7l0,0c0,1.5-1.2,2.7-2.7,2.7H48.1c-1.5,0-2.7-1.2-2.7-2.7l0,0 C45.4,351.4,46.6,350.2,48.1,350.2z"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M370.6,418.1c-6.2,6.7-10.8,9.4-10.5,2.3c0.7-21.5-37.1-118.7-37.1-118.7l11.2-0.8 C358.5,342.9,367.6,386.1,370.6,418.1z"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M423.6,459.1c-6.4,1.5-14.4,3.1-24.1,4.5c-3.6,0.5-7.5,1-11.7,1.5c-10,1.2-21.5,2.2-34.9,3 c-3.8,0.2-7.7,0.4-11.8,0.6c-7.6,0.3-15.8,0.6-24.5,0.8l-0.2-2.6v0c12.2-4.9,31.3-18,34.4-52.1c27.7-10.7,58.8,3.1,69.5,30.8 C422,450,423.1,454.5,423.6,459.1L423.6,459.1z"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M306.3,468.5c0,0,61.7-6.7,40.5-100.7c0,0,30.5,27.9,49.5,43.5s52.8,37,52.8,37S428.8,467.1,306.3,468.5z"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M306.3,468.5c0,0,61.7-6.7,40.5-100.7c0,0,30.5,27.9,49.5,43.5s52.8,37,52.8,37S428.8,467.1,306.3,468.5z"
});

var _ref48 = /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 141.5,
  cy: 465,
  r: 53.8
});

var _ref49 = /*#__PURE__*/React.createElement("circle", {
  className: "st3",
  cx: 141.5,
  cy: 465,
  r: 29.3
});

var _ref50 = /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 141.5,
  cy: 465,
  r: 17.6
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M201.7,448.9c0-34.7-27.6-62.9-61.6-62.9s-61.6,28.1-61.6,62.9c0,1.5,0.1,2.9,0.1,4.4h122.8 C201.7,451.8,201.7,450.3,201.7,448.9z"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M199.5,447.8c0-33.4-26.5-60.5-59.3-60.5s-59.3,27.1-59.3,60.5c0,1.4,0.1,2.8,0.1,4.2h118.3 C199.4,450.6,199.5,449.2,199.5,447.8z"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M199.5,447.8c0,1,0,1.9-0.1,2.9c0,0.4,0,0.9-0.1,1.3H81c0-0.4-0.1-0.9-0.1-1.3c0-1-0.1-1.9-0.1-2.9 c0-33.4,26.5-60.5,59.3-60.5S199.5,414.4,199.5,447.8z"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M199.4,450.7c0,0.4,0,0.9-0.1,1.3H81c0-0.4-0.1-0.9-0.1-1.3H199.4z"
});

var _ref55 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.9112 -0.412 0.412 0.9112 -110.2357 175.5102)",
  className: "st4",
  cx: 351.9,
  cy: 343.4,
  rx: 7.8,
  ry: 19.7
});

var _ref56 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.9112 -0.412 0.412 0.9112 -109.9093 175.7208)",
  className: "st3",
  cx: 352.6,
  cy: 342.8,
  rx: 7.8,
  ry: 19.7
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M334,300.8V311h-19.9c-1.9,0-3.7-0.1-5.5-0.4c-1.9-4.8-3.2-7.6-3.2-7.6l17.5-1.3L334,300.8z"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M334,309.7h-19.9c-17.5,0-31.6-13.1-31.6-29.2v-2.7c0-16.1,14.1-29.2,31.6-29.2l19.9,1.8V309.7z"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M301.3,266c0,0,11.9,6.4,5,17.1c0,0-8.4,13.8-21.6,12.5l-4.8-29.6C279.9,266,295.7,264.5,301.3,266z"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M296.7,265.4c3.8,0.1,7.4,2,9.7,5.1c2.1,2.9,3.4,7.2,0,12.6c0,0-8.4,13.8-21.6,12.5l-4.8-29.6 C285.5,265.5,291.1,265.3,296.7,265.4z"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M333.4,250.5L333.4,250.5c8.8,0,16,7.1,16,16v0v27.3c0,8.8-7.1,16-16,16h0l0,0l0,0V250.5L333.4,250.5z"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M334,250.5L334,250.5c8.8,0,16,7.1,16,16v0v27.3c0,8.8-7.1,16-16,16h0l0,0l0,0V250.5L334,250.5z"
});

var _ref63 = /*#__PURE__*/React.createElement("ellipse", {
  className: "st8",
  cx: 278.6,
  cy: 281.3,
  rx: 13.2,
  ry: 16.1
});

var _ref64 = /*#__PURE__*/React.createElement("polyline", {
  className: "st10",
  points: "138,355.6 143.7,368.4 153.4,355.6 "
});

var _ref65 = /*#__PURE__*/React.createElement("rect", {
  x: 119.7,
  y: 369,
  className: "st11",
  width: 47,
  height: 46.2
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M140.9,413v-5.2c-2.8,0-5.5-0.8-7.8-2.2l1.2-3.4c2.4,1.4,5.1,2.2,7.9,2.2c3.6,0,6.1-2.1,6.1-5 c0-2.8-2-4.5-5.8-6.1c-5.2-2-7.8-4.4-7.8-8.8c0-4.2,2.7-7.5,7.4-8.2v-5.2h2.6v5c2.3,0,4.6,0.6,6.6,1.8l-1.3,3.4 c-1.8-1.2-4-1.8-6.1-1.7c-3.9,0-4.8,2.3-4.8,4.4c0,2.7,1.3,4,5.7,5.8c5.3,2.1,8.5,4.8,8.5,9.3c0,4-2.8,7.8-8.1,8.7v5.3L140.9,413z"
});

var _ref67 = /*#__PURE__*/React.createElement("rect", {
  x: 51,
  y: 246.8,
  className: "st3",
  width: 7,
  height: 108
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M51,246.8c0,0-26,1-31,3s-20,1-20,1v28c0,0,17-4,26-1s28-4,28-4L51,246.8z"
});

var _ref69 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 78.5919 205.7202)",
  className: "st18 st19 st20 st21"
}, "Tripplin");

var SvgTriplin2 = function SvgTriplin2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ec20663a-47a1-42a3-991c-bc307f281f8f",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1114 593.5",
    style: {
      enableBackground: "new 0 0 1114 593.5"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTriplin2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/triplin2.423c94eb.svg";
export { ForwardRef as ReactComponent };